import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { EnvelopeSimple, Phone, MapPin, Clock, FacebookLogo, InstagramLogo, LinkedinLogo, Globe } from "@phosphor-icons/react";

export default function Contatti() {
  const [info, setInfo] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [sending, setSending] = useState(false);

  useEffect(() => { api.get("/public/contact").then(r => setInfo(r.data)); }, []);

  const send = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const r = await api.post("/public/contact-message", form);
      toast.success(r.data.message);
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) { toast.error("Errore invio"); }
    finally { setSending(false); }
  };

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  return (
    <div className="max-w-6xl mx-auto px-6 py-12">
      <div className="label-eyebrow">Contattaci</div>
      <h1 className="font-display text-5xl font-bold tracking-tight mt-3">Parliamone insieme</h1>
      <p className="text-muted-foreground mt-3">{info?.intro_text || "Siamo a tua disposizione per informazioni sui nostri servizi."}</p>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-12">
        {/* Contact info */}
        <div className="space-y-4">
          {info?.email && <ContactRow icon={EnvelopeSimple} label="Email" value={info.email} href={`mailto:${info.email}`} testid="contact-email" />}
          {info?.phone && <ContactRow icon={Phone} label="Telefono" value={info.phone} href={`tel:${info.phone}`} testid="contact-phone" />}
          {info?.address && <ContactRow icon={MapPin} label="Sede" value={`${info.address}, ${info.city}`} testid="contact-address" />}
          {info?.hours && <ContactRow icon={Clock} label="Orari" value={info.hours} testid="contact-hours" />}
          {info?.website && <ContactRow icon={Globe} label="Sito" value={info.website} href={info.website} testid="contact-web" />}

          <div className="flex gap-3 pt-3">
            {info?.social_facebook && <a href={info.social_facebook} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center hover:bg-purple-200"><FacebookLogo size={18} color="#6D28D9" weight="fill" /></a>}
            {info?.social_instagram && <a href={info.social_instagram} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center hover:bg-purple-200"><InstagramLogo size={18} color="#6D28D9" weight="fill" /></a>}
            {info?.social_linkedin && <a href={info.social_linkedin} target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center hover:bg-purple-200"><LinkedinLogo size={18} color="#6D28D9" weight="fill" /></a>}
          </div>
        </div>

        {/* Form */}
        <form onSubmit={send} className="kpi-card space-y-3" data-testid="contact-form">
          <h3 className="font-display text-xl font-semibold">Scrivici</h3>
          <div className="grid grid-cols-2 gap-2">
            <div><Label>Nome</Label><Input required value={form.name} onChange={upd("name")} data-testid="cf-name" /></div>
            <div><Label>Email</Label><Input type="email" required value={form.email} onChange={upd("email")} data-testid="cf-email" /></div>
          </div>
          <div><Label>Telefono</Label><Input type="tel" value={form.phone} onChange={upd("phone")} /></div>
          <div><Label>Oggetto</Label><Input value={form.subject} onChange={upd("subject")} /></div>
          <div><Label>Messaggio</Label><Textarea rows={5} required value={form.message} onChange={upd("message")} data-testid="cf-message" /></div>
          <Button type="submit" disabled={sending} className="w-full ht-gradient border-0" data-testid="cf-submit">
            {sending ? "Invio..." : "Invia messaggio"}
          </Button>
        </form>
      </div>
    </div>
  );
}

function ContactRow({ icon: Icon, label, value, href, testid }) {
  const inner = (
    <div className="flex items-start gap-4 p-4 rounded-xl border hover:border-purple-300 transition-colors">
      <div className="w-11 h-11 rounded-lg ht-gradient flex items-center justify-center shrink-0">
        <Icon size={20} color="white" weight="fill" />
      </div>
      <div>
        <div className="label-eyebrow">{label}</div>
        <div className="text-base font-medium mt-1" data-testid={testid}>{value}</div>
      </div>
    </div>
  );
  return href ? <a href={href}>{inner}</a> : inner;
}
